import apiClient from './apiClient';

// Use the main apiClient which has proper error handling
const api = apiClient;

// Salary Structure API functions
export const createSalaryStructure = async (data) => {
  const response = await api.post('/payroll/salary-structures', data);
  return response.data;
};

export const getSalaryStructures = async (params = {}) => {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.search) queryParams.append('search', params.search);
  if (params.status) queryParams.append('status', params.status);
  if (params.department) queryParams.append('department', params.department);
  if (params.sortBy) queryParams.append('sortBy', params.sortBy);
  if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
  if (params.startDate) queryParams.append('startDate', params.startDate);
  if (params.endDate) queryParams.append('endDate', params.endDate);

  const queryString = queryParams.toString();
  const url = `/payroll/salary-structures${queryString ? `?${queryString}` : ''}`;

  const response = await api.get(url);
  return response.data;
};

export const getSalaryStructure = async (id) => {
  const response = await api.get(`/payroll/salary-structures/${id}`);
  return response.data;
};

export const updateSalaryStructure = async (id, data) => {
  const response = await api.put(`/payroll/salary-structures/${id}`, data);
  return response.data;
};

export const updateSalaryStructureStatus = async (id, status) => {
  const response = await api.patch(`/payroll/salary-structures/${id}/status`, { status });
  return response.data;
};

export const deleteSalaryStructure = async (id) => {
  const response = await api.delete(`/payroll/salary-structures/${id}`);
  return response.data;
};
